// removed by extract-text-webpack-plugin
module.exports = {"Qr":"_2bT5ZzliYYlErI78olem-r"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Qr/Qr.css
// module id = 210
// module chunks = 0